import { InjectionToken } from '@angular/core';

import { StripeInstance } from 'ngx-stripe';

export interface StripeTenantMap {
	cz: StripeInstance;
	de: StripeInstance;
}

export const STRIPE_TENANT_MAP = new InjectionToken<StripeTenantMap>('StripeTenantMap');
